module.exports = __webpack_public_path__ + "img/16-3.2e1183ab.jpg";